import { render, staticRenderFns } from "./VdGroupDialog.vue?vue&type=template&id=cdd24e46&scoped=true"
import script from "./VdGroupDialog.vue?vue&type=script&lang=ts"
export * from "./VdGroupDialog.vue?vue&type=script&lang=ts"
import style0 from "./VdGroupDialog.vue?vue&type=style&index=0&id=cdd24e46&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdd24e46",
  null
  
)

export default component.exports